<div fxLayout="column" fxLayoutGap="16px">
    <h3>Selecione o tipo de contrato a ser gerado</h3>

    <div *ngIf="isLoading" fxLayoutAlign="center center"
        class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="loading-text">Carregando tipos de contrato...</span>
    </div>

    <div *ngIf="!isLoading && contractRoles.length === 0"
        class="no-roles-message" fxLayoutAlign="center center">
        <mat-icon>info</mat-icon>
        <span>Este parceiro não possui papéis configurados para geração de
            contrato.</span>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="16px grid"
        *ngIf="!isLoading && contractRoles.length > 0">
        <div *ngFor="let role of contractRoles" fxFlex="calc(33.33% - 16px)"
            fxFlex.lt-md="calc(50% - 16px)" fxFlex.lt-sm="100%">
            <mat-card class="role-card"
                [ngClass]="{'role-disabled': role.hasActiveContract, 'role-selected': currentSelection && currentSelection.type === role.type}"
                (click)="selectContractRole(role)">
                <mat-card-header>
                    <mat-icon mat-card-avatar>{{role.icon ||
                        'description'}}</mat-icon>
                    <mat-card-title>{{role.label}}</mat-card-title>
                    <mat-card-subtitle *ngIf="role.contractStatus">
                        <span [ngClass]="getStatusClass(role)"
                            class="status-chip">
                            {{getStatusLabel(role.contractStatus)}}
                        </span>
                    </mat-card-subtitle>
                </mat-card-header>

                <mat-card-content>
                    <p *ngIf="role.hasActiveContract"
                        class="contract-message contract-signed">
                        <mat-icon>check_circle</mat-icon>
                        Contrato já assinado
                    </p>

                    <p
                        *ngIf="role.contractStatus && role.contractStatus !== 'signed'"
                        class="contract-message contract-in-progress">
                        <mat-icon>access_time</mat-icon>
                        Contrato em andamento
                    </p>
                </mat-card-content>
            </mat-card>
            <!-- Botão Remover -->
            <button
                *ngIf="role.contractId && role.contractStatus !== 'signed' && role.contractStatus !== 'canceled' && role.contractStatus !== 'archived'"
                mat-button color="warn" class="remove-button"
                (click)="triggerRemoveContract(role, $event)"
                matTooltip="Remover este contrato em andamento">
                Remover
            </button>
        </div>
    </div>
</div>